"use client";

import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { ComponentLoggingEventParams } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { ColorTokenKey } from "@faire/web-api--source/indigofair/data/ColorTokenKey";
import { IBannerComponent } from "@faire/web-api--source/indigofair/data/IBannerComponent";
import { Column } from "@faire/web/slate/Layout";
import { cn } from "@faire/web/tools/cn";
import { useViewport } from "@faire/web/ui/hooks/useViewport";

import { SDUIBannerTextContent } from "../BannerTextContent/SDUIBannerTextContent";

import { DecorativeImage } from "./DecorativeImage";

type DecorativeTextBannerProps = {
  bannerComponent: IBannerComponent;
  loggingData: ComponentLoggingEventParams;
};

export const SDUIDecorativeTextBannerRenderer: React.FC<
  DecorativeTextBannerProps
> = ({ bannerComponent, loggingData }) => {
  const { isMobile } = useViewport();
  const { style, responsive_images } = bannerComponent;

  const { background_color } = style ?? {};

  return (
    <Column
      className={cn("h-[233px] w-full md:h-[423px]", isMobile ? "p-4" : "p-8")}
      justify="center"
      align={isMobile ? "start" : "center"}
      style={{
        backgroundColor: getSlateColorToken(
          background_color,
          ColorTokenKey.COLOR_TOKEN_KEY_UNKNOWN
        ),
      }}
    >
      <DecorativeImage
        index={0}
        responsiveImage={responsive_images}
        position="top-left"
      />
      <DecorativeImage
        index={1}
        responsiveImage={responsive_images}
        position="top-right"
      />
      <DecorativeImage
        index={2}
        responsiveImage={responsive_images}
        position="bottom-left"
      />
      <DecorativeImage
        index={3}
        responsiveImage={responsive_images}
        position="bottom-right"
      />
      <SDUIBannerTextContent
        className="relative z-[1] w-[90%] items-start md:w-[450px] md:items-center"
        bannerComponent={bannerComponent}
        loggingData={loggingData}
        typgraphyHyphens="none"
      />
    </Column>
  );
};
